import { Component, OnInit, Input, AfterViewInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { LineGraphConfigurations } from "./line-graph-models";
import { TitleConfigurations, TitleLineConfigurations } from "../title/title.configurations";
import { KlaHttpService } from "../services/kla.http.service";
import { CommonModule } from '@angular/common';
import { TitleComponent } from '../title/title.component';
import { LineChartComponent } from 'app/shared/charts/line-chart/line-chart.component';
import { AudioComponent } from '../audio/audio.component';

@Component({
  selector: 'kla-line-graph',
  templateUrl: './line-graph.component.html',
  styleUrls: ['./line-graph.component.scss', '../../../app.component.scss'],
  standalone: true,
  imports: [ CommonModule, TitleComponent, LineChartComponent, AudioComponent ]
})
export class LineGraphComponent implements OnInit, AfterViewInit {

  @Input()
  public titleConfig: TitleConfigurations;

  @Input()
  public lineConfig: TitleLineConfigurations;

  @Input()
  public chartId: string;

  @Input()
  public audioConfig: any;

  @ViewChild('panel', {static: true})
  public panel: ElementRef;

  public chartConfig: LineGraphConfigurations;

  constructor(private http: KlaHttpService) { }

  ngOnInit() {
    this.http.getChartData("kla-line-chart", this.chartId).subscribe(
      (data) => {
        this.chartConfig = {
          ...data,
          value: data.currentValues.find(v => v.center).value,
        };
        if (!this.chartConfig) {
          console.error("Please provide line chart configurations");
        } else {
          this.resize();
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  ngAfterViewInit(): void {
  }

  @HostListener('window:resize')
  onResize() {
    this.resize();
  }

  private resize() {
    let rectangle = this.panel.nativeElement.getBoundingClientRect();
    let width = rectangle.width - 60;
    width = width < 450 ? 450 : width;
    this.chartConfig.width = width;
    this.chartConfig.height = width * 2 / 3;
    this.chartConfig.visible = true;
  }
}
